var User = function(params){
    var self = this;
    self.id = ko.observable(params && params.id || 0);
    self.name = ko.observable(params && params.name || 'Guest');
};
